import React from 'react';

// main footer
export default function MainFooter() {
  return (
    <div className={' mb-3 mt-5 border-top'}>
      <div className="container py-2 text-center text-secondary small">
        Copyright © {new Date().getFullYear()} - OCCDEC Annotation Dashboard
      </div>
    </div>
  );
}
